import styled from 'styled-components'

import StepperButtonMinusIcon from '../icons/StepperButtonMinus'
import StepperButtonPlusIcon from '../icons/StepperButtonPlus'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 18px;

  ${({ noMargin }) => !noMargin && 'margin: 8px 0 8px;'}

  border: 1px solid
    ${({ theme, error }) =>
      error
        ? theme?.['-ds-error-300']?.value
        : theme?.['-ds-neutral-400']?.value};

  ${({ rounded }) =>
    rounded &&
    `
    border-radius: 6px;
  `}

  ${({ open }) =>
    open &&
    `
    border-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}

  background-color: white;

  &:focus {
    border-color: ${({ theme }) => theme.brand.jungle};
  }

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    pointer-events: none;
    top: 0;
    right: 0;

    height: 100%;
    padding: 0 18px;

    color: ${({ theme }) => theme?.['-ds-neutral-400']?.value};
  }

  svg {
    width: 13px;
    height: 6px;
  }
`

export const Option = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  margin-bottom: 15px;
`

export const Label = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  div {
    color: ${({ theme }) => theme.colors.labelGrey};
    font-size: 14px;
  }
`

export const Footer = styled.footer`
  width: 100%;
  margin-top: 20px;
  text-align: right;
`

export const CloseButton = styled.button.attrs({ type: 'button' })`
  display: inline-block;
  appearance: none;
  outline: 0;
  border: none;
  background: none;

  padding: 10px 20px;
  padding-right: 0;
  color: ${({ theme }) => theme.brand.jungle};

  text-transform: uppercase;
`

const Stepper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100px;
`

const StepButton = styled.button.attrs({ type: 'button' })`
  width: 26px;
  height: 26px;
  padding: 0;

  appearance: none;
  border: none;
  background: none;
  border-radius: 0;

  text-align: center;

  color: ${({ theme, active }) => (active ? theme.brand.jungle : '#C9C9C9')};

  svg {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
`

export const renderStepper = ({
  input: { value, onChange },
  guests,
  capacity,
  minValue = 0,
  increaseLabel = 'Plus',
  decreaseLabel = 'Minus',
}) => (
  <Stepper>
    <StepButton
      onClick={() => onChange(value - 1 >= minValue ? value - 1 : value)}
      active={value > minValue}
      aria-label={decreaseLabel}
    >
      <StepperButtonMinusIcon />
    </StepButton>
    <div>{value}</div>
    <StepButton
      onClick={() => onChange(guests < capacity ? value + 1 : value)}
      active={guests < capacity}
      aria-label={increaseLabel}
    >
      <StepperButtonPlusIcon />
    </StepButton>
  </Stepper>
)
